import styled from "@emotion/styled";
import { useMemo } from "react";
import { ITag } from "../types/TagTypes";

const TooltipText = styled.span`
  font-size: 14px;
  letter-spacing: 0px;
  color: #ffffff;
`;

const MORE_TAGS_MAX_TOOLTIP_ROWS = 10;

interface Props {
  selectedTags: ITag[];
}

export default function MoreTagsTooltipContent(props: Props): JSX.Element {
  const { selectedTags } = props;

  const selectedTagsExcludingTwoFirsts = selectedTags.slice(
    2,
    selectedTags.length
  );

  let tooltipContent: JSX.Element[];

  tooltipContent = selectedTagsExcludingTwoFirsts.map((elem, index) => {
    if (index <= MORE_TAGS_MAX_TOOLTIP_ROWS - 1) {
      return (
        <TooltipText key={`tooltip_text_any_${elem._id}`}>
          {`${elem.category} -> ${elem.name}`}
        </TooltipText>
      );
    }
    return null;
  });

  const thereIsMoreTagsThanTheLimit =
    selectedTagsExcludingTwoFirsts.length - MORE_TAGS_MAX_TOOLTIP_ROWS;

  thereIsMoreTagsThanTheLimit > 0 &&
    tooltipContent.push(
      <TooltipText key={`tooltip_text_any_${thereIsMoreTagsThanTheLimit}`}>
        {`and ${thereIsMoreTagsThanTheLimit} more ${
          thereIsMoreTagsThanTheLimit === 1 ? "tag" : "tags"
        }...`}
      </TooltipText>
    );

  return <>{tooltipContent}</>;
}
